// Module
var code = "<select class=\"dd-field-select\"> <option value=\"\"></option> <% _(_datavisualization.dataSource.fieldList).each(function(f) { %> <option value=\"{{ f.field }}\">{{ f.field }}</option> <% }) %> </select> ";
// Exports
export default code;